import { FormattedMessage, defineMessage } from 'react-intl'
import { Wrapper } from 'routes/ThankYou/styles'
import Text from 'components/shared/Text'
import ImageInfoBox from 'components/shared/ImageInfoBox'
import * as LINKS from 'constants/links'
import { useApp } from 'store/steps'
import { useResolutions } from 'store/resolutions'
import restaurantsPhotoMobile from 'assets/images/thankYou/restaurantsPhoto_mobile.png'
import restaurantsPhoto from 'assets/images/thankYou/restaurantsPhoto.png'

export const ThankYouHungryExcitements = () => {
    const { language } = useApp()
    const { isTablet } = useResolutions()

    return (
        <Wrapper
            gap={24}
            align={['center', 'flex-start']}
            justify="space-between"
            isLongTitle={language === 'en'}
            isFullWidth
        >
            <Text
                variant="heading2"
                color="grayscale_900"
                align={['center', 'left']}
            >
                <Text as="span" color="primary_500" variant="heading2">
                    <FormattedMessage
                        id="order.thankyou.restaurants_and_bars_tile_heading_part_1"
                        defaultMessage="Dla głodnych"
                    />
                </Text>{' '}
                <FormattedMessage
                    id="order.thankyou.restaurants_and_bars_tile_heading_part_2"
                    defaultMessage="nie tylko wrażeń!"
                />
            </Text>
            <ImageInfoBox
                image={isTablet ? restaurantsPhotoMobile : restaurantsPhoto}
                imageAlt="restaurants"
                title={defineMessage({
                    id: 'order.thankyou.restaurants_and_bars_tile_subheading',
                    defaultMessage: 'Restauracje i bary',
                })}
                desc={defineMessage({
                    id: 'order.thankyou.restaurants_and_bars_tile_message',
                    defaultMessage:
                        'Wybierz się w kulinarną podróż dookoła świata – w parku czeka aż 5 restauracji i 4 basenowe koktajl bary.',
                })}
                linkText={defineMessage({
                    id: 'global.btn.more',
                    defaultMessage: 'Więcej',
                })}
                linkUrl={LINKS.RESTAURANTS_LINK}
                hasExtraSpace={language === 'uk' && !isTablet}
            />
        </Wrapper>
    )
}
